<template>
    <span class="material-icons" :data-type="BT.BOT_RESPONSE" v-if="blockType === BT.BOT_RESPONSE"> send </span>
    <span class="material-icons" :data-type="BT.ASSIGN_OWNER" v-else-if="blockType === BT.ASSIGN_OWNER">
        person_pin
    </span>
    <span class="material-icons" :data-type="BT.START_POINT" v-else-if="blockType === BT.START_POINT"> home </span>
    <span class="material-icons" :data-type="BT.ATTACHMENT_INPUT" v-else-if="blockType === BT.ATTACHMENT_INPUT">
        attachment
    </span>
    <span class="material-icons" :data-type="BT.FILTER" v-else-if="blockType === BT.FILTER"> filter_alt </span>
    <span class="material-icons" :data-type="BT.USER_INPUT" v-else-if="blockType === BT.USER_INPUT">
        record_voice_over
    </span>
    <span class="material-icons" :data-type="BT.GO_TO_STEP" v-else-if="blockType === BT.GO_TO_STEP"> cable </span>
    <span class="material-icons" :data-type="BT.ADD_TO_SEGMENT" v-else-if="blockType === BT.ADD_TO_SEGMENT">
        pie_chart
    </span>
    <span class="material-icons" :data-type="BT.REMOVE_FROM_SEGMENT" v-else-if="blockType === BT.REMOVE_FROM_SEGMENT">
        pie_chart
    </span>
    <span class="material-icons" :data-type="BT.DEFAULT_FALLBACK" v-else-if="blockType === BT.DEFAULT_FALLBACK">
        heart_broken
    </span>
    <span class="material-icons" :data-type="BT.FALLBACK" v-else-if="blockType === BT.FALLBACK"> heart_broken </span>
    <span class="material-icons" :data-type="BT.QUESTION" v-else-if="blockType === BT.QUESTION"> quiz </span>
    <span class="material-icons" :data-type="BT.SET_ATTRIBUTE" v-else-if="blockType === BT.SET_ATTRIBUTE">
        data_object
    </span>
    <span class="material-icons" :data-type="BT.CLOSE_CHAT" v-else-if="blockType === BT.CLOSE_CHAT">
        mark_chat_read
    </span>
    <span class="material-icons" :data-type="BT.SUCCESS" v-else-if="blockType === BT.SUCCESS"> check_circle </span>
    <span class="material-icons" :data-type="BT.FAILURE" v-else-if="blockType === BT.FAILURE"> cancel </span>
    <span class="material-icons" :data-type="BT.FLOW" v-else-if="blockType === BT.FLOW">schema</span>
    <span class="material-icons" :data-type="BT.PLATFORM_FLOW" v-else-if="blockType === BT.PLATFORM_FLOW">schema</span>
    <span class="material-icons" :data-type="BT.CREATE_TICKET" v-else-if="blockType === BT.CREATE_TICKET">
        local_activity
    </span>
    <span class="material-icons" :data-type="BT.TICKET_UPDATE" v-else-if="blockType === BT.TICKET_UPDATE">
        local_activity
    </span>
    <span class="material-icons" :data-type="BT.TAG_CHAT" v-else-if="blockType === BT.TAG_CHAT"> bookmark </span>
    <span class="material-icons" :data-type="BT.REMOVE_TAG" v-else-if="blockType === BT.REMOVE_TAG">
        bookmark_remove
    </span>
    <span class="material-icons" :data-type="BT.TRANSFER_CHAT" v-else-if="blockType === BT.TRANSFER_CHAT">
        support_agent
    </span>
    <span class="material-icons" :data-type="BT.TRANSFER_TO_CHATBOT" v-else-if="blockType === BT.TRANSFER_TO_CHATBOT">
        fast_forward
    </span>
    <span class="material-icons" :data-type="BT.SEND_TRANSCRIPT" v-else-if="blockType === BT.SEND_TRANSCRIPT">
        attach_email
    </span>
    <span class="material-icons" :data-type="BT.SEND_SMS" v-else-if="blockType === BT.SEND_SMS"> sms </span>
    <span class="material-icons" :data-type="BT.SEND_MAIL" v-else-if="blockType === BT.SEND_MAIL"> mail </span>
    <span class="material-icons" :data-type="BT.CREATE_EVENT" v-else-if="blockType === BT.CREATE_EVENT"> event </span>
    <span class="material-icons" :data-type="BT.CREATE_RESERVATION" v-else-if="blockType === BT.CREATE_RESERVATION">
        calendar_month
    </span>
    <span class="material-icons" :data-type="BT.RESERVATION_OPEN_URL" v-else-if="blockType === BT.RESERVATION_OPEN_URL">
        event
    </span>
    <span
        class="material-icons"
        :data-type="BT.RESERVATION_SELECT_DAY"
        v-else-if="blockType === BT.RESERVATION_SELECT_DAY"
    >
        calendar_month
    </span>
    <span
        class="material-icons"
        :data-type="BT.RESERVATION_EVENT_LIST"
        v-else-if="blockType === BT.RESERVATION_EVENT_LIST"
    >
        event_note
    </span>
    <span
        class="material-icons"
        :data-type="BT.RESERVATION_SELECT_TIME"
        v-else-if="blockType === BT.RESERVATION_SELECT_TIME"
    >
        calendar_month
    </span>
    <span class="material-icons text-light" :data-type="BT.WEBHOOK" v-else-if="blockType === BT.WEBHOOK">
        webhook
    </span>
    <span class="material-icons" :data-type="BT.GET_LOCATION" v-else-if="blockType === BT.GET_LOCATION">
        location_on
    </span>
    <span class="material-icons" :data-type="BT.SET_DEPARTMENT" v-else-if="blockType === BT.SET_DEPARTMENT">
        category
    </span>

    <img
        class="custom-block-logo"
        src="/static/img/openai.png"
        :data-type="BT.AI_BOT_RESPONSE"
        v-else-if="blockType === BT.AI_BOT_RESPONSE"
    />
    <div class="custom-block-logo ai-assistant" v-else-if="blockType === BT.AI_ASSISTANT" :data-type="BT.AI_ASSISTANT">
        <OpenaiIcon />
    </div>
    <span class="material-icons" :data-type="BT.CREATE_TASK" v-else-if="blockType === BT.CREATE_TASK"> add_task </span>
    <span class="material-icons" :data-type="BT.SUPPRESSION_ADD" v-else-if="blockType === BT.SUPPRESSION_ADD">
        block
    </span>
    <span class="material-icons" :data-type="BT.SUPPRESSION_REMOVE" v-else-if="blockType === BT.SUPPRESSION_REMOVE">
        lock_open
    </span>

    <span class="material-icons" :data-type="BT.DEFAULT_TIMEOUT" v-else-if="blockType === BT.DEFAULT_TIMEOUT">
        timer
    </span>
    <span class="material-icons" :data-type="BT.TIMEOUT" v-else-if="blockType === BT.TIMEOUT"> timer </span>
    <span
        class="material-icons"
        :data-type="BT.SEND_WP_BUSINESS_MESSAGE"
        v-else-if="blockType === BT.SEND_WP_BUSINESS_MESSAGE"
    >
        send
    </span>

    <InstagramIcon
        class="custom-block-logo"
        :data-type="BT.INSTAGRAM_COMMENT_REPLY"
        v-else-if="blockType === BT.INSTAGRAM_COMMENT_REPLY"
    />
    <InstagramIcon
        class="custom-block-logo"
        :data-type="BT.INSTAGRAM_COMMENT_DELETE"
        v-else-if="blockType === BT.INSTAGRAM_COMMENT_DELETE"
    />
    <InstagramIcon
        class="custom-block-logo"
        :data-type="BT.INSTAGRAM_COMMENT_SHOW"
        v-else-if="blockType === BT.INSTAGRAM_COMMENT_SHOW"
    />
    <InstagramIcon
        class="custom-block-logo"
        :data-type="BT.INSTAGRAM_COMMENT_HIDE"
        v-else-if="blockType === BT.INSTAGRAM_COMMENT_HIDE"
    />
    <InstagramIcon
        class="custom-block-logo"
        :data-type="BT.AI_INSTAGRAM_FLOW"
        v-else-if="blockType === BT.AI_INSTAGRAM_FLOW"
    />
    <InstagramIcon
        class="custom-block-logo"
        :data-type="BT.INSTAGRAM_COMMENT_REPLY_AS_PRIVATE"
        v-else-if="blockType === BT.INSTAGRAM_COMMENT_REPLY_AS_PRIVATE"
    />
    <AIClassificationIcon
        class="custom-block-logo"
        :data-type="BT.AI_MENU_FLOW"
        v-else-if="blockType === BT.AI_MENU_FLOW"
    />
    <AIClassificationIcon
        class="custom-block-logo"
        :data-type="BT.AI_CLASSIFICATION"
        v-else-if="blockType === BT.AI_CLASSIFICATION"
    />
    <span class="material-icons" :data-type="BT.OTP_WHATSAPP_FLOW" v-else-if="blockType === BT.OTP_WHATSAPP_FLOW">
        sms
    </span>
    <span class="material-icons" :data-type="BT.OTP_SMS_FLOW" v-else-if="blockType === BT.OTP_SMS_FLOW"> sms </span>
    <span class="material-icons" :data-type="BT.OTP_MAIL_FLOW" v-else-if="blockType === BT.OTP_MAIL_FLOW"> mail </span>
    <span class="material-icons" :data-type="BT.SLEEP" v-else-if="blockType === BT.SLEEP"> bedtime </span>
    <span class="material-icons" :data-type="BT.NOOP" v-else-if="blockType === BT.NOOP"> handshake </span>
    <span class="material-icons" :data-type="BT.WEBHOOK" v-else-if="blockType === BT.WEBHOOK"> webhook </span>
    <span class="material-icons" :data-type="BT.LOOP" v-else-if="blockType === BT.LOOP"> loop </span>
    <span class="material-icons" :data-type="BT.LOOP_NEXT" v-else-if="blockType === BT.LOOP_NEXT"> next_plan </span>
    <span class="material-icons" :data-type="BT.LOOP_BREAK" v-else-if="blockType === BT.LOOP_BREAK">
        keyboard_return
    </span>
    <span class="material-icons" :data-type="BT.LOOP_CONTINUE" v-else-if="blockType === BT.LOOP_CONTINUE">
        next_plan
    </span>
    <span class="material-icons" :data-type="BT.LOOP_FINISH" v-else-if="blockType === BT.LOOP_FINISH">
        check_circle
    </span>
    <span class="material-icons" :data-type="BT.FIND_CONTACTS" v-else-if="blockType === BT.FIND_CONTACTS">
        person_search
    </span>
    <span class="material-icons" :data-type="BT.FIND_CONTACTS" v-else-if="blockType === BT.FIND_CONTACT">
        person_search
    </span>
    <span class="material-icons" :data-type="BT.TERMINATE_AUTOMATION" v-else-if="blockType === BT.TERMINATE_AUTOMATION">
        waving_hand
    </span>
    <span class="material-icons" :data-type="BT.FIND_CHATS" v-else-if="blockType === BT.FIND_CHATS"> quickreply </span>
    <span class="material-icons" :data-type="BT.FIND_CHAT" v-else-if="blockType === BT.FIND_CHAT"> quickreply </span>
    <span class="material-icons" :data-type="BT.STRING_FORMAT" v-else-if="blockType === BT.STRING_FORMAT">
        text_fields
    </span>
    <span class="material-icons" :data-type="BT.NUMBER_FORMAT" v-else-if="blockType === BT.NUMBER_FORMAT">
        calculate
    </span>
    <span class="material-icons" :data-type="BT.DATE_FORMAT" v-else-if="blockType === BT.DATE_FORMAT">
        calendar_month
    </span>

    <span class="material-icons" :data-type="BT.WAIT_FOR" v-else-if="blockType === BT.WAIT_FOR"> hourglass_top </span>

    <img
        class="custom-block-logo"
        src="/static/img/openai.png"
        :data-type="BT.ASK_AI"
        v-else-if="blockType === BT.ASK_AI"
    />

    <span class="material-icons" :data-type="BT.CREATE_CONTACT" v-else-if="blockType === BT.CREATE_CONTACT">
        person_add
    </span>
    <span class="material-icons" :data-type="BT.UPDATE_CONTACT" v-else-if="blockType === BT.UPDATE_CONTACT">
        person_add
    </span>
    <span class="material-icons" :data-type="BT.CATCH_WEBHOOK" v-else-if="blockType === BT.CATCH_WEBHOOK">
        webhook
    </span>
    <span class="material-icons" :data-type="BT.RECORDS_FROM_CSV" v-else-if="blockType === BT.RECORDS_FROM_CSV">
        upload_file
    </span>

    <span class="material-icons" :data-type="BT.TABLE_CREATE_RECORD" v-else-if="blockType === BT.TABLE_CREATE_RECORD">
        add_circle
    </span>
    <span class="material-icons" :data-type="BT.TABLE_UPDATE_RECORD" v-else-if="blockType === BT.TABLE_UPDATE_RECORD">
        edit
    </span>
    <span class="material-icons" :data-type="BT.TABLE_DELETE_RECORD" v-else-if="blockType === BT.TABLE_DELETE_RECORD">
        delete
    </span>
    <span class="material-icons" :data-type="BT.TABLE_FIND_RECORD" v-else-if="blockType === BT.TABLE_FIND_RECORD">
        search
    </span>
    <span class="material-icons" :data-type="BT.TABLE_FIND_RECORDS" v-else-if="blockType === BT.TABLE_FIND_RECORDS">
        list
    </span>
    <span
        class="material-icons"
        :data-type="BT.GET_SUPSIS_RECORD_BY_ID"
        v-else-if="blockType === BT.GET_SUPSIS_RECORD_BY_ID"
    >
        search
    </span>
    <span class="material-icons" :data-type="BT.SHOW_WIDGET" v-else-if="blockType === BT.SHOW_WIDGET">
        open_in_new
    </span>

    <ZohoIcon class="material-icons zoho" :data-type="BT.TABLE_FIND_RECORDS" v-else-if="blockType.startsWith('ZOHO')" />

    <span
        class="material-icons"
        :data-type="BT.REPLY_TRENDYOL_QUESTION"
        v-else-if="blockType === BT.REPLY_TRENDYOL_QUESTION"
    >
        reply
    </span>
    <span class="material-icons voice-agent-icon" :data-type="BT.AI_CALL" v-else-if="blockType === BT.AI_CALL">
        record_voice_over
    </span>
    
    <span class="material-icons" :data-type="BT.CACHE_WRITE" v-else-if="blockType === BT.CACHE_WRITE">
        save
    </span>
    <span class="material-icons" :data-type="BT.CACHE_READ" v-else-if="blockType === BT.CACHE_READ">
        download
    </span>
    <span class="material-icons" :data-type="BT.CACHE_EXTEND" v-else-if="blockType === BT.CACHE_EXTEND">
        update
    </span>
    <span class="material-icons" :data-type="BT.CACHE_DELETE" v-else-if="blockType === BT.CACHE_DELETE">
        delete_forever
    </span>
    
    <a-icon type="youtube" :data-type="BT.YOUTUBE_REPLY_COMMENT" v-else-if="blockType === BT.YOUTUBE_REPLY_COMMENT" />
    <a-icon type="youtube" :data-type="BT.YOUTUBE_UPDATE_COMMENT_STATUS" v-else-if="blockType === BT.YOUTUBE_UPDATE_COMMENT_STATUS" />
    <a-icon type="youtube" :data-type="BT.YOUTUBE_SET_MODERATION_STATUS" v-else-if="blockType === BT.YOUTUBE_SET_MODERATION_STATUS" />
    
    <a-icon type="google" :data-type="BT.GOOGLE_BUSINESS_REPLY_REVIEW" v-else-if="blockType === BT.GOOGLE_BUSINESS_REPLY_REVIEW" />
    <a-icon type="google" :data-type="BT.GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS" v-else-if="blockType === BT.GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS" />
    <a-icon type="google" :data-type="BT.GOOGLE_PLAY_REPLY_REVIEW" v-else-if="blockType === BT.GOOGLE_PLAY_REPLY_REVIEW" />
    <a-icon type="google" :data-type="BT.GOOGLE_PLAY_UPDATE_REVIEW_STATUS" v-else-if="blockType === BT.GOOGLE_PLAY_UPDATE_REVIEW_STATUS" />
    <a-icon type="apple" :data-type="BT.APP_STORE_REPLY_REVIEW" v-else-if="blockType === BT.APP_STORE_REPLY_REVIEW" />
    <a-icon type="apple" :data-type="BT.APP_STORE_UPDATE_REVIEW_STATUS" v-else-if="blockType === BT.APP_STORE_UPDATE_REVIEW_STATUS" />
    <a-icon type="apple" :data-type="BT.APP_STORE_DELETE_REVIEW_RESPONSE" v-else-if="blockType === BT.APP_STORE_DELETE_REVIEW_RESPONSE" />
    <span class="material-icons" v-else> offline_bolt </span>
</template>

<script>
import AUTOMATION_BLOCK_TYPES from "../../../AutomationBlockTypes";
import AIClassificationIcon from "../../../../../../components/svg/icons/AIClassificationIcon.vue";
import WhatsappIcon from "../../../../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import OpenaiIcon from "../../../../Chatbot/pages/integrations/svg/OpenaiIcon.vue";
import InstagramIcon from "../../../../Chatbot/pages/integrations/svg/InstagramIcon.vue";
import ZohoIcon from "../../../../Chatbot/pages/integrations/svg/ZohoIcon.vue";

export default {
    name: "BlockIconPreview",
    components: { ZohoIcon, WhatsappIcon, OpenaiIcon, AIClassificationIcon, InstagramIcon },
    props: {
        blockType: {
            type: String,
            required: false,
            default: "",
        },
    },
    data: function () {
        return {
            BT: AUTOMATION_BLOCK_TYPES,
        };
    },
};
</script>

<style lang="scss">
.material-icons {
    &.voice-agent-icon {
        background: linear-gradient(135deg, #ff6b6b, #4ecdc4, #45b7d1, #96c93d, #ffbe0b);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        animation: rainbow 5s ease infinite;
    }
    &.zoho {
        width: 30px;
        height: 20px;
    }

    &[data-type="BOT_RESPONSE"] {
        transform: rotate(-40deg);
    }

    &[data-type="FLOW"] {
        transform: rotate(180deg);
    }

    &[data-type="ATTACHMENT_INPUT"] {
        transform: rotate(-45deg);
    }

    &[data-type="GO_TO_STEP"] {
        color: red;
        transform: rotate(87deg);
    }

    &[data-type="ADD_TO_SEGMENT"] {
        color: #22314a;
    }

    &[data-type="REMOVE_FROM_SEGMENT"] {
        color: #22314a;
    }

    &[data-type="SET_DEPARTMENT"] {
        color: white;
        background-color: #f30879 !important;
        border-radius: 50%;
        padding: 2px;
    }
    &[data-type="GOOGLE_BUSINESS_REPLY_REVIEW"],
    &[data-type="GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS"] {
        color: #4285F4;
    }
    &[data-type="GOOGLE_PLAY_REPLY_REVIEW"],
    &[data-type="GOOGLE_PLAY_UPDATE_REVIEW_STATUS"] {
        color: #01875f;
    }
    &[data-type="YOUTUBE_REPLY_COMMENT"],
    &[data-type="YOUTUBE_UPDATE_COMMENT_STATUS"],
    &[data-type="YOUTUBE_SET_MODERATION_STATUS"] {
        color: #FF0000;
    }
    &[data-type="APP_STORE_REPLY_REVIEW"],
    &[data-type="APP_STORE_UPDATE_REVIEW_STATUS"],
    &[data-type="APP_STORE_DELETE_REVIEW_RESPONSE"] {
        color: #007aff;
    }
}

svg[data-type="AI_CLASSIFICATION"] {
    width: 40px;
}

.custom-block-logo {
    background: none !important;

    &[data-type="AI_ASSISTANT"] {
        border-radius: 50%;
        padding: 2px;

        svg {
            width: 20px;
            height: 20px;
            fill: #fff;

            g {
                fill: #fff !important;
            }
        }
    }
}
</style>
